import React from 'react';
import LeftNav from './../common/leftnav/leftnav';
import HeaderTop from './../common/headerTop/headerTop';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Useractivity } from './../../services/useractivity.service';
import CommonMessage from './../common/commonMessage';
import ReactTooltip from 'react-tooltip';
import { ResourceService } from './../../services/resource.service';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import BmrSlider from '../common/topRightHeader/bmrSlider';
import $ from 'jquery';

class Webactivitylogs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            username: localStorage.getItem("email"),
            webstartdate: null,
            webenddate: null,
            instancestartdate: null,
            instanceenddate: null,
            getactivitytype: "web",
            instancetype: false,
            webActivties: [],
            resetWebActivities: [],
            resetInstanceActivities: [],
            instanceactivities: [],
            message: "",
            iswebDateActive: true,
            iswebDescActive: false,
            isInstanceDescActive: false,
            isInstanceDateActive: true,
            isInstanceOpActive: false,
            webdesctoggle: false,
            webdatetoggle: true,
            instancedesctoggle: false,
            instancedatetoggle: true,
            instanceoptoggle: false,
            defaultinstanceenddate: "",
            defaultinstancestartdate: "",
            defaultwebenddate: "",
            defaultwebstartdate: "",
            webemptymessage: "View logs of all the web activities for your account",
            instanceemptymessage: "View logs of all the activities for your compute instances",
            webStartGenerate: null,
            webEndGenerate: null,
            instanceStartGenerate: null,
            instanceEndGenerate: null,
            instanceTabLoad: true,
            isUserSubscribed: false,
            webIndexCount: 0,
            instIndexCount: 0,
            count: 50,
            webActivtiesPaged: [],
            instActivtiesPaged: [],
            isFilterShow: false,
            isOpChecked: false,
            isEmailChecked: false,
            isIpChecked: false
        };

        this.getActivityType = this.getActivityType.bind(this);
        this.loadcss = this.loadcss.bind(this);
        this.generate = this.generate.bind(this);
        this.setSortable = this.setSortable.bind(this);
        this.resetClick = this.resetClick.bind(this);
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.hideDropDown = this.hideDropDown.bind(this);

    };
    resetClick = () => {
        let instActivtiesPaged = [...this.state.resetInstanceActivities];
        let webActivtiesPaged = [...this.state.resetWebActivities];

        if(instActivtiesPaged.length > this.state.count) instActivtiesPaged = instActivtiesPaged.slice(0, this.state.count);
        if(webActivtiesPaged.length > this.state.count) webActivtiesPaged = webActivtiesPaged.slice(0, this.state.count);

        this.setState({
            webstartdate: this.state.defaultwebstartdate,
            webenddate: this.state.defaultwebenddate,
            instancestartdate: this.state.defaultinstancestartdate,
            instanceenddate: this.state.defaultinstanceenddate,
            webStartGenerate: this.state.defaultwebstartdate,
            webEndGenerate: this.state.defaultwebenddate,
            instanceStartGenerate: this.state.defaultinstancestartdate,
            instanceEndGenerate: this.state.defaultinstanceenddate,
            webActivties: this.state.resetWebActivities,
            instanceactivities: this.state.resetInstanceActivities,
            instIndexCount: 0,
            webIndexCount: 0,
            instActivtiesPaged: instActivtiesPaged,
            webActivtiesPaged: webActivtiesPaged
        });
    };
    generate = (param) => {

        this.setState({
            webemptymessage: "There are no web activities logs to show for the selected duration",
            instanceemptymessage: "There are no instance activity logs to show for the selected duration"
        });
        if(param === "web") {
            if(this.state.webstartdate === null || this.state.webenddate === null) {
                this.setState({
                    message: "Please select Startdate and End Date",

                });
                return;
            }
            if(new Date(this.state.webstartdate) > new Date(this.state.webenddate)) {
                this.setState({
                    message: "End date cannot be less than start date"
                });
                return;
            }
            this.setState({
                isAction: true
            });
            Useractivity.getDetailsByType(this.state.webstartdate, this.state.webenddate, "web")
                .then((resp) => {
                    if(resp === false) {
                        this.setState({
                            message: "Error While fetching Web activities, Try again!",
                            isAction: false

                        });
                        return;
                    }
                    let webActivtiesPaged = [...resp];
                    if(resp.length > this.state.count) webActivtiesPaged = webActivtiesPaged.slice(0, this.state.count);

                    this.setState({
                        webStartGenerate: this.state.webstartdate,
                        webEndGenerate: this.state.webenddate,
                        webActivties: resp,
                        isAction: false,
                        webActivtiesPaged: webActivtiesPaged,
                        webIndexCount: 0
                    });
                });
        }
        else if(param === "instance") {
            if(this.state.instancestartdate === null || this.state.instanceenddate === null) {
                this.setState({
                    message: "Please select Startdate and End Date"
                });
                return;
            }
            if(new Date(this.state.instancestartdate) > new Date(this.state.instanceenddate)) {
                this.setState({
                    message: "End date cannot be less than start date"
                });
                return;
            }
            this.setState({
                isAction: true
            });
            Useractivity.getDetailsByType(this.state.instancestartdate, this.state.instanceenddate, "instance")
                .then((resp) => {
                    if(resp === false) {
                        this.setState({
                            message: "Error While fetching Web activities, Try again!",
                            isAction: false

                        });
                        return;
                    }
                    let instActivtiesPaged = [...resp];
                    if(resp.length > this.state.count) instActivtiesPaged = instActivtiesPaged.slice(0, this.state.count);

                    this.setState({
                        instanceStartGenerate: this.state.instancestartdate,
                        instanceEndGenerate: this.state.instanceenddate,
                        instanceactivities: resp,
                        isAction: false,
                        instActivtiesPaged: instActivtiesPaged,
                        instIndexCount: 0
                    });
                });
        }
    };
    getActivityType = (param) => {

        if(param === "web") {
            this.setState({
                getactivitytype: "web",
                instancetype: false
            });

        }
        else {
            if(this.state.instanceTabLoad) {
                this.loadUserConfig();
                this.loadInstanceData(param);
            }

            this.setState({
                getactivitytype: "instance",
                instancetype: true
            });
        }
    };

    loadUserConfig() {
        let isIpChecked = false; let isOpChecked = false; let isWhenChecked = false; let isEmailChecked = false;
        Useractivity.getUserConfig().then(resp => {
            if(resp?.instActivities) {
                let instActivities = resp.instActivities;
                if(instActivities.indexOf(',')) {
                    let instActivArr = instActivities.split(",");
                    for(var i = 0; i < instActivArr.length; i++) {
                        switch(instActivArr[i]) {
                            case "1":
                                isOpChecked = true;
                                break;
                            case "2":
                                isEmailChecked = true;
                                break;
                            case "3":
                                isIpChecked = true;
                                break;
                            case "4":
                                isWhenChecked = true;
                                break;
                        }
                    }
                } else {
                    switch(instActivities) {
                        case "1":
                            isOpChecked = true;
                            break;
                        case "2":
                            isEmailChecked = true;
                            break;
                        case "3":
                            isIpChecked = true;
                            break;
                        case "4":
                            isWhenChecked = true;
                            break;
                    }
                }
                this.setState({ isOpChecked: isOpChecked, isEmailChecked: isEmailChecked, isIpChecked: isIpChecked, isWhenChecked: isWhenChecked });
            }
        });
    }

    setSortable = (type, eve) => {


        if(type === "web") {
            let items = [...this.state.webActivties];
            //if(items.length > this.state.count) items = [...this.state.webActivtiesPaged];

            if(eve === "description") {
                if(this.state.webdesctoggle) {
                    items.sort(function (a, b) {
                        if(a.description.toLowerCase() < b.description.toLowerCase()) { return -1; }
                        if(a.description.toLowerCase() > b.description.toLowerCase()) { return 1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.description.toLowerCase() < b.description.toLowerCase()) { return 1; }
                        if(a.description.toLowerCase() > b.description.toLowerCase()) { return -1; }
                        return 0;
                    });
                }
                this.setState({
                    webdesctoggle: !this.state.webdesctoggle,
                    iswebDateActive: false,
                    iswebDescActive: true
                });
            }
            else if(eve === "date") {
                if(this.state.webdatetoggle) {
                    items.sort(function (a, b) {
                        return new Date(a.date) - new Date(b.date);
                    });
                }
                else {
                    items.sort(function (a, b) {
                        return new Date(b.date) - new Date(a.date);
                    });
                }
                this.setState({
                    webdatetoggle: !this.state.webdatetoggle,
                    iswebDescActive: false,
                    iswebDateActive: true
                });
            }
            this.setState({
                webActivties: items,
                webActivtiesPaged: items.slice(0, this.state.count),
                webIndexCount: 0
            });

        }
        else if(type === "instance") {
            let items = [...this.state.instanceactivities];
            //if(items.length > this.state.count) items = [...this.state.instanceactivities];

            if(eve === "description") {
                if(this.state.instancedesctoggle) {
                    items.sort(function (a, b) {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                        return 0;
                    });
                }
                this.setState({
                    instancedesctoggle: !this.state.instancedesctoggle,
                    isInstanceDescActive: true,
                    isInstanceOpActive: false,
                    isInstanceDateActive: false
                });
            }
            else if(eve === "date") {
                if(this.state.instancedatetoggle) {
                    items.sort(function (a, b) {
                        return new Date(a.date) - new Date(b.date);
                    });
                }
                else {
                    items.sort(function (a, b) {
                        return new Date(b.date) - new Date(a.date);
                    });
                }
                this.setState({
                    instancedatetoggle: !this.state.instancedatetoggle,
                    isInstanceDescActive: false,
                    isInstanceOpActive: false,
                    isInstanceDateActive: true
                });
            }
            else if(eve === "operation") {
                if(this.state.instanceoptoggle) {
                    items.sort(function (a, b) {
                        if(a.operation.toLowerCase() < b.operation.toLowerCase()) { return -1; }
                        if(a.operation.toLowerCase() > b.operation.toLowerCase()) { return 1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.operation.toLowerCase() < b.operation.toLowerCase()) { return 1; }
                        if(a.operation.toLowerCase() > b.operation.toLowerCase()) { return -1; }
                        return 0;
                    });
                }
                this.setState({
                    instanceoptoggle: !this.state.instanceoptoggle,
                    isInstanceDescActive: false,
                    isInstanceOpActive: true,
                    isInstanceDateActive: false
                });
            }
            let instActivtiesPaged = [...items];
            this.setState({
                instanceactivities: items,
                instActivtiesPaged: instActivtiesPaged.slice(0, this.state.count),
                instIndexCount: 0

            });

        }

    };

    componentDidMount() {

        $(".inst_actInnerWrap").scroll(function () {
            var scrollInsActivity = $(".inst_actInnerWrap").scrollTop();
            if(scrollInsActivity >= 160) {
                $(".activities_instance").addClass("fix_instanceTable");
            }
            else {
                $(".activities_instance").removeClass("fix_instanceTable");
            }
        });

        this.setState({
            isAction: true
        });
        this.checkForSubscription();

        document.addEventListener('mouseup', this.hideDropDown, false);
    }

    hideDropDown(event) {
        if(event === undefined) return;
        var container = document.getElementById('filter_wrp');
        if(container && !container.contains(event.target)) {
            this.setState({ isFilterShow: false });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mouseup', this.hideDropDown, false);
    }

    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details"

                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isUserSubscribed: true
                });
                this.loadWebData("web");
            }
            else {
                this.setState({
                    isUserSubscribed: false
                });
                this.loadWebData("web");
            }

        });
    };

    loadWebData = (param) => {
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 7);
        let endDate = new Date();

        Useractivity.getDetailsByType(startDate, endDate, param)
            .then((resp) => {
                if(resp === false) {
                    this.setState({
                        message: "Error While fetching Web activities, Try again!",
                        isAction: false
                    });
                    return;
                }
                let web = [];
                let webitems = resp;
                webitems.sort(function (a, b) {
                    return new Date(b.date) - new Date(a.date);
                });
                for(let i = 0; i < webitems.length; i++) {
                    let d = new Date(webitems[i].date);
                    let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                    let obj = {
                        "name": webitems[i].name,
                        "description": webitems[i].description,
                        "ipaddress": webitems[i].ipaddress,
                        "operation": webitems[i].operation,
                        "username": webitems[i].username,
                        "date": createdDate
                    };
                    web.push(obj);
                }

                let webActivtiesPaged = [...web];
                if(web.length > this.state.count) webActivtiesPaged = webActivtiesPaged.slice(0, this.state.count);
                this.setState({
                    webstartdate: startDate,
                    webenddate: new Date(),
                    defaultwebstartdate: startDate,
                    defaultwebenddate: new Date(),
                    isAction: false,
                    webStartGenerate: startDate,
                    webEndGenerate: new Date(),
                    instancestartdate: startDate,
                    instanceenddate: new Date(),
                    defaultinstancestartdate: startDate,
                    defaultinstanceenddate: new Date(),
                    instanceStartGenerate: startDate,
                    instanceEndGenerate: new Date(),
                    webActivties: web,
                    webActivtiesPaged: webActivtiesPaged,
                    resetWebActivities: web,
                    isAction: false
                });
            });
    };
    loadInstanceData = (param) => {
        this.setState({
            isAction: true
        });
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 7);
        let endDate = new Date();

        Useractivity.getDetailsByType(startDate, endDate, param)
            .then((resp) => {
                if(resp === false) {
                    this.setState({
                        message: "Error While fetching Web activities, Try again!",
                        isAction: false

                    });
                    return;
                }
                let instance = [];
                let instanceitems = resp;
                instanceitems.sort(function (a, b) {
                    return new Date(b.date) - new Date(a.date);
                });

                for(let i = 0; i < instanceitems.length; i++) {
                    let d = new Date(instanceitems[i].date);
                    let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                    let obj = {
                        "name": instanceitems[i].name,
                        "description": instanceitems[i].description,
                        "ipaddress": instanceitems[i].ipaddress,
                        "operation": instanceitems[i].operation,
                        "username": instanceitems[i].username,
                        "date": createdDate
                    };
                    instance.push(obj);
                }
                let instActivtiesPaged = [...instance];
                if(instance.length > this.state.count) instActivtiesPaged = instActivtiesPaged.slice(0, this.state.count);

                this.setState({
                    instActivtiesPaged: instActivtiesPaged,
                    instanceactivities: instance,
                    resetInstanceActivities: instance,
                    isAction: false,
                    instanceTabLoad: false
                });
            });
    };

    loadDate = () => {
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 7);

        this.setState({
            webstartdate: startDate,
            webenddate: new Date(),
            defaultwebstartdate: startDate,
            defaultwebenddate: new Date(),
            instancestartdate: startDate,
            instanceenddate: new Date(),
            defaultinstancestartdate: startDate,
            defaultinstanceenddate: new Date(),
            isAction: false,
            webStartGenerate: startDate,
            webEndGenerate: new Date(),
            instanceStartGenerate: startDate,
            instanceEndGenerate: new Date()
        });
    };

    getUserActivities = () => {
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 10);
        let endDate = new Date();

        Useractivity.getUserActivityData(startDate, endDate).then((resp) => {
            if(resp === false) {
                this.setState({
                    message: "Error while fetching user Activity, Try again!",
                    isAction: false

                });
                return;
            }
            let webitems = resp[1];
            webitems.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
            });
            let instanceitems = resp[0];
            instanceitems.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
            });
            this.setState({
                webActivties: webitems,
                instanceactivities: instanceitems,
                resetInstanceActivities: instanceitems,
                resetWebActivities: webitems,
                isAction: false
            });
            this.loadDate();
        });
    };

    loadcss = () => {

        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://www.idrivecompute.com/webapp/css/web-activity.css";


        const link1 = document.createElement("link");
        link1.rel = "stylesheet";
        link1.href = "https://www.idrivecompute.com/webapp/css/datepicker.css";


        document
            .head
            .appendChild(link);
        document
            .head
            .appendChild(link1);

    };

    handleWebNextClick = (event) => {
        let webActivties = [...this.state.webActivties];
        let webIndexCount = this.state.webIndexCount + this.state.count;
        let endCount = webIndexCount + this.state.count;
        if(endCount > webActivties.length) endCount = webActivties.length;
        this.setState({
            webIndexCount: webIndexCount,
            webActivtiesPaged: webActivties.slice(webIndexCount, endCount)
        });
        event.preventDefault();
    };


    handleWebPreviousClick = (event) => {
        let webActivties = [...this.state.webActivties];
        let webIndexCount = this.state.webIndexCount - this.state.count;
        this.setState({
            webIndexCount: this.state.webIndexCount - this.state.count,
            webActivtiesPaged: webActivties.slice(webIndexCount, this.state.webIndexCount)
        });
        event.preventDefault();
    };

    handleInstPreviousClick = (event) => {
        let instanceactivities = [...this.state.instanceactivities];
        let instIndexCount = this.state.instIndexCount - this.state.count;
        this.setState({
            instIndexCount: this.state.instIndexCount - this.state.count,
            instActivtiesPaged: instanceactivities.slice(instIndexCount, this.state.instIndexCount)
        });
        event.preventDefault();
    };

    handleInstNextClick = (event) => {
        let instanceactivities = [...this.state.instanceactivities];
        let instIndexCount = this.state.instIndexCount + this.state.count;
        let endCount = instIndexCount + this.state.count;
        if(endCount > instanceactivities.length) endCount = instanceactivities.length;
        this.setState({
            instIndexCount: instIndexCount,
            instActivtiesPaged: instanceactivities.slice(instIndexCount, endCount)
        });
        event.preventDefault();
    };

    saveUsersActivity() {
        //if(!this.state.isEmailChecked && !this.state.isOpChecked && !this.state.isWhenChecked && !this.state.isEmailChecked) return;
        let userConfig = '';
        if(this.state.isOpChecked) userConfig = "1,";
        if(this.state.isEmailChecked) userConfig = userConfig + "2,";
        if(this.state.isIpChecked) userConfig = userConfig + "3,";
        if(this.state.isWhenChecked) userConfig = userConfig + "4";

        if(userConfig.charAt(userConfig.length - 1) === ',') userConfig = userConfig.substring(0, userConfig.length - 1);
        if(userConfig === '') userConfig = ' ';

        this.setState({ isFilterShow: false });
        Useractivity.saveUserConfig(userConfig).then(resp => {
            if(resp && resp.userId === undefined) this.setState({ isFilterShow: true });
        });
    }

    render() {

        return (
            <div>
                <body className="main_nav_module web_activity_module">
                    <main>
                        <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                            <div className="loader_icon"></div>
                        </div>
                        <LeftNav isActive={ 'logs' }></LeftNav>

                        <div className="main_container">
                            <header className="header_wrap">
                                <HeaderTop showCreate={ true } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                                <div className="header_wrap_bottom">
                                    <div className="bottom_navbar">
                                        <div className="bn_left">
                                            <div className="computer_no"> <span className="text bold_600">Activity Logs</span><span className="sub_text">(View a list of your recent account-related activities)</span> </div>
                                        </div>
                                    </div>
                                </div>
                            </header>
                            <NotificationSlider />
                            <section className="main_section pagination__wrap">
                                <div className="main_body_container">
                                    <div className="mainBody_colWrap">
                                        <div className="webActivity_container">
                                            <div className="webActivity_tab_wrap">
                                                <div className="custom_tabs_wrap">
                                                    <ul>
                                                        <li className={ this.state.getactivitytype === "web" ? "web_activity active" : "web_activity" } onClick={ () => { this.getActivityType("web"); } }><span className="svg_wrap"></span>Web Activities</li>
                                                        <li className={ this.state.getactivitytype === "instance" ? "instace_activity active" : "instace_activity" } onClick={ () => { this.getActivityType("instance"); } }><span className="svg_wrap"></span>Instance Activities</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="activities_web" style={ this.state.instancetype ? { display: "none" } : { display: "block" } }>
                                                <div className="webActivity_date_filter">
                                                    <div className="cal_dd">
                                                        <div className="cal_dd_inner d_flex">
                                                            <div className="calendar">
                                                                <div className="calendar_inner">
                                                                    <div className="calendar_item_wrap">
                                                                        <div className="calendar_item">
                                                                            <p>From Date</p>
                                                                            <div className="input_text_wrap">
                                                                                <DatePicker
                                                                                    selected={ this.state.webstartdate }
                                                                                    onChange={ (date) => this.setState({
                                                                                        webstartdate: date
                                                                                    }) }
                                                                                    maxDate={ new Date() }
                                                                                    peekNextMonth
                                                                                    showMonthDropdown
                                                                                    showYearDropdown
                                                                                    dropdownMode="select"
                                                                                    placeholderText="mm-dd-yy"
                                                                                    className="input_text"
                                                                                    popperPlacement="top-start"
                                                                                />
                                                                                <span className="icon"></span> </div>

                                                                        </div>
                                                                        <div className="calendar_item">
                                                                            <p>End Date</p>
                                                                            <div className="input_text_wrap">
                                                                                <DatePicker
                                                                                    selected={ this.state.webenddate }
                                                                                    onChange={ (date) => this.setState({
                                                                                        webenddate: date
                                                                                    }) }
                                                                                    maxDate={ new Date() }
                                                                                    peekNextMonth
                                                                                    showMonthDropdown
                                                                                    showYearDropdown
                                                                                    dropdownMode="select"
                                                                                    placeholderText="mm-dd-yy"
                                                                                    className="input_text"
                                                                                    popperPlacement="top-start"
                                                                                />
                                                                                <span className="icon"></span> </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="calendar_btn_wrap">
                                                                        <input type="button" value="Generate" className="common_cta_btn blue" onClick={ () => this.generate("web") }></input>
                                                                        <input type="button" value="Reset" className="common_cta_btn cancel" onClick={ () => { this.resetClick(); } }></input>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="webActivity_table clearfix">
                                                    <div className="table_head_options">
                                                        <div className="lhs_wrap">
                                                            <p>Activity logs from <span className="highlight">{ this.state.webStartGenerate === null ? "" : this.state.webStartGenerate.toLocaleDateString() }</span> to <span className="highlight">{ this.state.webEndGenerate === null ? "" : this.state.webEndGenerate.toLocaleDateString() }</span></p>
                                                        </div>
                                                        <div className="rhs_wrap" style={ { display: "none" } }>
                                                            <div className="pdf_download"><span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                <g>
                                                                    <g>
                                                                        <g>
                                                                            <path fill="#F24C4C" d="M393.7,149.4l-77.8-77.8c-1.5-1.5-3.4-2.3-5.5-2.3H147.1c-17.2,0-31.1,14-31.1,31.1v311.1     c0,17.2,14,31.1,31.1,31.1h217.8c17.2,0,31.1-14,31.1-31.1V154.9C396,152.8,395.2,150.8,393.7,149.4z M318.2,95.9l51.2,51.2     h-35.7c-8.6,0-15.6-7-15.6-15.6V95.9z M380.4,411.6c0,8.6-7,15.6-15.6,15.6H147.1c-8.6,0-15.6-7-15.6-15.6V100.4     c0-8.6,7-15.6,15.6-15.6h155.6v46.7c0,17.2,14,31.1,31.1,31.1h46.7V411.6z"></path>
                                                                            <path fill="#F24C4C" d="M295.7,297.7c-7.2-5.7-14-11.5-18.6-16c-5.9-5.9-11.2-11.7-15.8-17.1c7.2-22.1,10.3-33.5,10.3-39.6     c0-25.8-9.3-31.1-23.3-31.1c-10.6,0-23.3,5.5-23.3,31.9c0,11.6,6.4,25.7,19,42.1c-3.1,9.4-6.7,20.3-10.8,32.5     c-2,5.9-4.1,11.3-6.3,16.3c-1.8,0.8-3.6,1.6-5.3,2.5c-6.2,3.1-12.1,5.9-17.5,8.5c-24.8,11.8-41.2,19.5-41.2,34.9     c0,11.2,12.1,18.1,23.3,18.1c14.5,0,36.3-19.3,52.2-51.9c16.6-6.5,37.1-11.4,53.4-14.4c13,10,27.4,19.6,34.4,19.6     c19.3,0,23.3-11.2,23.3-20.5c0-18.4-21-18.4-31.1-18.4C315.1,294.9,306.7,295.8,295.7,297.7z M186,364.9c-4.4,0-7.5-2.1-7.8-2.5     c0-5.5,16.4-13.3,32.3-20.8c1-0.5,2-1,3.1-1.5C202,357,190.4,364.9,186,364.9z M240.4,225.6c0-16.3,5.1-16.3,7.8-16.3     c5.5,0,7.8,0,7.8,15.6c0,3.3-2.2,11.5-6.2,24.3C243.7,239.8,240.4,231.7,240.4,225.6z M246.4,309.2c0.5-1.4,1-2.7,1.4-4.1     c2.9-8.7,5.5-16.4,7.8-23.4c3.2,3.6,6.7,7.2,10.4,10.9c1.5,1.5,5.1,4.7,9.9,8.8C266.4,303.5,256.2,306.1,246.4,309.2z      M333.8,313.3c0,3.5,0,4.9-7.2,5c-2.1-0.5-7-3.3-13.1-7.5c2.2-0.2,3.8-0.4,4.7-0.4C329.7,310.4,333,311.6,333.8,313.3z"></path>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg></span>Download PDF</div>
                                                        </div>
                                                    </div>
                                                    <div className="tabular_data_wrap">
                                                        <div className="table_header">
                                                            <ul>
                                                                <li className="th">
                                                                    <div className="col col1">
                                                                        <div className="header_sort_wrap" onClick={ () => this.setSortable("web", "description") }>Description<span className={ this.state.iswebDescActive ? this.state.webdesctoggle ? "sort_icon active toggle_sort" : "sort_icon active" : "sort_icon" }></span></div>
                                                                    </div>
                                                                    <div className="col col2">
                                                                        <div className="header_sort_wrap" onClick={ () => this.setSortable("web", "date") }>Date & Time<span className={ this.state.iswebDateActive ? this.state.webdatetoggle ? "sort_icon active toggle_sort" : "sort_icon active" : "sort_icon" }></span></div>
                                                                    </div>
                                                                    <div className="col col3">
                                                                        <div>IP Address</div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="table_data">
                                                            { this.state.webActivties.length <= 0 && !this.state.isAction ?
                                                                <ul>
                                                                    <li>
                                                                        <div className="outer_empty_wrap fullPageEmpty">
                                                                            <div className="inner_empty_wrap">
                                                                                <div className="svg_wrap empty_icon webActivitylogs_empty"></div>
                                                                                <p className="empty_title">{ this.state.webemptymessage }</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                                :
                                                                <ul>
                                                                    { this.state.webActivtiesPaged.map((data, index) =>
                                                                        <li className="tr" key={ index }>
                                                                            <div className="col col1">

                                                                                <div className={
                                                                                    data.description.indexOf("Profile") !== -1 ? "web_logs_des profile_update" :
                                                                                        data.description.indexOf("Password") !== -1 ? "web_logs_des profile_update" :
                                                                                            data.description.indexOf("Email") !== -1 ? "web_logs_des update_email" :
                                                                                                data.description.indexOf("logged in") !== -1 ? "web_logs_des logged_in" :
                                                                                                    data.description.indexOf("2FA Verification") !== -1 ? "web_logs_des logged_in" :
                                                                                                        data.description.indexOf("logged out") !== -1 ? "web_logs_des logged_out" : "web_logs_des profile_update"
                                                                                }><span className="desc">{ data.description }</span></div>
                                                                            </div>
                                                                            <div className="col col2"> { data.date } </div>
                                                                            <div className="col col3">{ data.ipaddress }</div>
                                                                        </li>
                                                                    ) }

                                                                </ul>
                                                            }
                                                        </div>
                                                        <div className="pagination_inner__box remove-bg" style={ { display: this.state.webActivties.length > this.state.count ? '' : 'none' } }>
                                                            <div className="Page_navigation">
                                                                <ul className="pagination_ul">
                                                                    <li className={ this.state.webIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                        <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page" onClick={ (event) => { this.handleWebPreviousClick(event); } }>
                                                                            <ReactTooltip id="prev-page" place="top" effect="solid">Previous</ReactTooltip>
                                                                            <span aria-hidden="true">«</span>
                                                                            <span className="sr-only">Previous</span>
                                                                        </a>
                                                                    </li>
                                                                    <li className="page-item">
                                                                        <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                            { this.state.webIndexCount + 1 } - { (this.state.webIndexCount + this.state.count) > this.state.webActivties.length ? this.state.webActivties.length : (this.state.webIndexCount + this.state.count) }
                                                                        </a>
                                                                    </li>
                                                                    <li className={ this.state.webIndexCount + this.state.count > this.state.webActivties.length - 1 ? "page-item disabled" : "page-item" }>
                                                                        <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { this.handleWebNextClick(event); } }>
                                                                            <ReactTooltip id="next-page" place="top" effect="solid">Next</ReactTooltip>
                                                                            <span aria-hidden="true">»</span>
                                                                            <span className="sr-only">Next</span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                            <div className="activities_instance" style={ this.state.instancetype ? { display: "block" } : { display: "none" } } >
                                                <div className="webActivity_date_filter">
                                                    <div className="cal_dd">
                                                        <div className="cal_dd_inner d_flex">
                                                            <div className="calendar">
                                                                <div className="calendar_inner">
                                                                    <div className="calendar_item_wrap">
                                                                        <div className="calendar_item">
                                                                            <p>From Date</p>
                                                                            <div className="input_text_wrap">
                                                                                <DatePicker
                                                                                    dateFormat="MM/dd/yyyy"
                                                                                    selected={ this.state.instancestartdate }
                                                                                    onChange={ (date) => this.setState({
                                                                                        instancestartdate: date
                                                                                    }) }
                                                                                    peekNextMonth
                                                                                    showMonthDropdown
                                                                                    showYearDropdown
                                                                                    maxDate={ new Date() }
                                                                                    dropdownMode="select"
                                                                                    placeholderText="mm-dd-yy"
                                                                                    className="input_text"
                                                                                    popperPlacement="top-start"
                                                                                />
                                                                                <span className="icon"></span> </div>
                                                                        </div>
                                                                        <div className="calendar_item">
                                                                            <p>End Date</p>
                                                                            <div className="input_text_wrap">
                                                                                <DatePicker
                                                                                    dateFormat="MM/dd/yyyy"
                                                                                    selected={ this.state.instanceenddate }
                                                                                    onChange={ (date) => this.setState({
                                                                                        instanceenddate: date
                                                                                    }) }
                                                                                    peekNextMonth
                                                                                    showMonthDropdown
                                                                                    showYearDropdown
                                                                                    maxDate={ new Date() }
                                                                                    dropdownMode="select"
                                                                                    placeholderText="mm-dd-yy"
                                                                                    className="input_text"
                                                                                    popperPlacement="top-start"
                                                                                />
                                                                                <span className="icon"></span> </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="calendar_btn_wrap">
                                                                        <input type="button" value="Generate" className="common_cta_btn blue" onClick={ () => this.generate("instance") }></input>
                                                                        <input type="button" value="Reset" className="common_cta_btn cancel" onClick={ () => { this.resetClick(); } }></input>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="webActivity_table clearfix" >
                                                    <div className="table_head_options">
                                                        <div className="lhs_wrap">
                                                            <p>Instance logs from <span className="highlight">{ this.state.instanceStartGenerate === null ? "" : this.state.instanceStartGenerate.toLocaleDateString() }</span> to <span className="highlight">{ this.state.instanceEndGenerate === null ? "" : this.state.instanceEndGenerate.toLocaleDateString() }</span></p>
                                                        </div>
                                                        <div className="rhs_wrap" style={ { display: "none" } }>
                                                            <div className="pdf_download"><span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                <g>
                                                                    <g>
                                                                        <g>
                                                                            <path fill="#F24C4C" d="M393.7,149.4l-77.8-77.8c-1.5-1.5-3.4-2.3-5.5-2.3H147.1c-17.2,0-31.1,14-31.1,31.1v311.1     c0,17.2,14,31.1,31.1,31.1h217.8c17.2,0,31.1-14,31.1-31.1V154.9C396,152.8,395.2,150.8,393.7,149.4z M318.2,95.9l51.2,51.2     h-35.7c-8.6,0-15.6-7-15.6-15.6V95.9z M380.4,411.6c0,8.6-7,15.6-15.6,15.6H147.1c-8.6,0-15.6-7-15.6-15.6V100.4     c0-8.6,7-15.6,15.6-15.6h155.6v46.7c0,17.2,14,31.1,31.1,31.1h46.7V411.6z"></path>
                                                                            <path fill="#F24C4C" d="M295.7,297.7c-7.2-5.7-14-11.5-18.6-16c-5.9-5.9-11.2-11.7-15.8-17.1c7.2-22.1,10.3-33.5,10.3-39.6     c0-25.8-9.3-31.1-23.3-31.1c-10.6,0-23.3,5.5-23.3,31.9c0,11.6,6.4,25.7,19,42.1c-3.1,9.4-6.7,20.3-10.8,32.5     c-2,5.9-4.1,11.3-6.3,16.3c-1.8,0.8-3.6,1.6-5.3,2.5c-6.2,3.1-12.1,5.9-17.5,8.5c-24.8,11.8-41.2,19.5-41.2,34.9     c0,11.2,12.1,18.1,23.3,18.1c14.5,0,36.3-19.3,52.2-51.9c16.6-6.5,37.1-11.4,53.4-14.4c13,10,27.4,19.6,34.4,19.6     c19.3,0,23.3-11.2,23.3-20.5c0-18.4-21-18.4-31.1-18.4C315.1,294.9,306.7,295.8,295.7,297.7z M186,364.9c-4.4,0-7.5-2.1-7.8-2.5     c0-5.5,16.4-13.3,32.3-20.8c1-0.5,2-1,3.1-1.5C202,357,190.4,364.9,186,364.9z M240.4,225.6c0-16.3,5.1-16.3,7.8-16.3     c5.5,0,7.8,0,7.8,15.6c0,3.3-2.2,11.5-6.2,24.3C243.7,239.8,240.4,231.7,240.4,225.6z M246.4,309.2c0.5-1.4,1-2.7,1.4-4.1     c2.9-8.7,5.5-16.4,7.8-23.4c3.2,3.6,6.7,7.2,10.4,10.9c1.5,1.5,5.1,4.7,9.9,8.8C266.4,303.5,256.2,306.1,246.4,309.2z      M333.8,313.3c0,3.5,0,4.9-7.2,5c-2.1-0.5-7-3.3-13.1-7.5c2.2-0.2,3.8-0.4,4.7-0.4C329.7,310.4,333,311.6,333.8,313.3z"></path>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg></span>Download PDF</div>
                                                        </div>
                                                    </div>
                                                    <div className="inst_actWrap" >
                                                        <div className="filter_wrp" id="filter_wrp">
                                                            <div className={ this.state.isFilterShow ? "filter_icon" : "filter_icon active" } onClick={ () => this.setState({ isFilterShow: !this.state.isFilterShow }) }></div>
                                                            <div className="filter_dropdown" style={ { display: this.state.isFilterShow ? "block" : "none" } }>
                                                                <ul className="filter_list">
                                                                    <li className={ this.state.isOpChecked ? "check_container active" : "check_container" } onMouseDown={ () => this.setState({ isOpChecked: !this.state.isOpChecked }) }>
                                                                        <label className="check_lbl">
                                                                            <input type="checkbox" className="input_check" id="operation_field" name="operation_field" checked={ this.state.isOpChecked } />
                                                                            <span className="checkmark"></span>Operation
                                                                        </label>
                                                                    </li>
                                                                    <li className={ this.state.isEmailChecked ? "check_container active" : "check_container" } onMouseDown={ () => this.setState({ isEmailChecked: !this.state.isEmailChecked }) } >
                                                                        <label className="check_lbl">
                                                                            <input type="checkbox" className="input_check" id="email_field" name="email_field" checked={ this.state.isEmailChecked } />
                                                                            <span className="checkmark"></span>Email
                                                                        </label>
                                                                    </li>
                                                                    <li className={ this.state.isIpChecked ? "check_container active" : "check_container" } onMouseDown={ () => this.setState({ isIpChecked: !this.state.isIpChecked }) } >
                                                                        <label className="check_lbl">
                                                                            <input type="checkbox" className="input_check" id="ip_field" name="ip_field" checked={ this.state.isIpChecked } />
                                                                            <span className="checkmark"></span>IP Address
                                                                        </label>
                                                                    </li>
                                                                    <li className={ this.state.isWhenChecked ? "check_container active" : "check_container" } onMouseDown={ () => this.setState({ isWhenChecked: !this.state.isWhenChecked }) } >
                                                                        <label className="check_lbl">
                                                                            <input type="checkbox" className="input_check" id="when_field" name="when_field" checked={ this.state.isWhenChecked } />
                                                                            <span className="checkmark"></span>When
                                                                        </label>
                                                                    </li>
                                                                    <li className="save_opt" onClick={ () => this.saveUsersActivity() }>
                                                                        {/* <div className={ !this.state.isEmailChecked && !this.state.isOpChecked && !this.state.isWhenChecked && !this.state.isEmailChecked ? "common_btn btn_primary disabled" : "common_btn btn_primary" }
                                                                            disabled={ !this.state.isEmailChecked && !this.state.isOpChecked && !this.state.isWhenChecked && !this.state.isEmailChecked }> */}
                                                                        <div className="common_btn btn_primary" >
                                                                            <p className="nowrap">Save current view</p>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className="inst_actInnerWrap">
                                                            <div className="tabular_data_wrap">
                                                                <div className="table_header">
                                                                    <ul>
                                                                        <li className="th">
                                                                            <div className="col col1 instance_field_col">
                                                                                <div className="header_sort_wrap" onClick={ () => this.setSortable("instance", "description") }>Instances<span className={ this.state.isInstanceDescActive ? this.state.instancedesctoggle ? "sort_icon active toggle_sort" : "sort_icon active" : "sort_icon" }></span></div>
                                                                            </div>
                                                                            <div className={ this.state.isOpChecked ? "col col2 operation_field_col" : "col col2 operation_field_col col-hide" }>
                                                                                <div className="header_sort_wrap" onClick={ () => this.setSortable("instance", "operation") }>Operation<span className={ this.state.isInstanceOpActive ? this.state.instanceoptoggle ? "sort_icon active toggle_sort" : "sort_icon active" : "sort_icon" }></span></div>
                                                                            </div>
                                                                            <div className={ this.state.isEmailChecked ? "col col3 email_field_col" : "col col3 email_field_col col-hide" }>
                                                                                <div>Email</div>
                                                                            </div>
                                                                            <div className={ this.state.isIpChecked ? "col col4 ip_field_col" : "col col4 ip_field_col col-hide" }>
                                                                                <div>IP Address</div>
                                                                            </div>
                                                                            <div className={ this.state.isWhenChecked ? "col col5 when_field_col" : "col col5 when_field_col col-hide" }>
                                                                                <div className="header_sort_wrap" onClick={ () => this.setSortable("instance", "date") }>When<span className={ this.state.isInstanceDateActive ? this.state.instancedatetoggle ? "sort_icon active toggle_sort" : "sort_icon active" : "sort_icon" }></span></div>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="table_data">
                                                                    { this.state.instanceactivities.length <= 0 && !this.state.isAction ?
                                                                        <ul>
                                                                            <li>
                                                                                <div className="outer_empty_wrap fullPageEmpty">
                                                                                    <div className="inner_empty_wrap">
                                                                                        <div className="svg_wrap empty_icon instActivitylogs_empty"></div>
                                                                                        <p className="empty_title">{ this.state.instanceemptymessage }</p>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                        :
                                                                        <ul>
                                                                            { this.state.instActivtiesPaged.map((instance, ind) =>
                                                                                <li className="tr" key={ ind }>
                                                                                    <div className="col col1 instance_field_col">

                                                                                        <div className="name_icon"><span className="svg_wrap debian"> <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                                                                                            <path fill="#FFFFFF" d="M12.1,27.2c-0.7-0.3-1.4-0.6-2.1-1c-1.4-0.8-2.5-1.9-3.4-3.2c-0.5-0.7-0.9-1.4-1.2-2.1  c-0.3-0.7-0.6-1.5-0.8-2.2c-0.2-0.8-0.4-1.6-0.5-2.4c-0.1-0.8-0.1-1.7,0-2.5c0.1-1.7,0.6-3.3,1.4-4.8C6,8.2,6.4,7.5,7,6.9  c0.5-0.7,1.2-1.3,1.8-1.8c2.8-2.1,6.5-2.8,9.9-1.9c0.8,0.2,1.7,0.6,2.4,1c0.8,0.4,1.5,1,2.2,1.7c2.6,2.7,3.4,6.5,2.1,10  c-0.7,1.7-1.9,3.1-3.5,4.1c-1.6,0.9-3.5,1.2-5.2,0.8c-0.9-0.2-1.7-0.6-2.4-1.2c-0.7-0.6-1.2-1.3-1.6-2.1c-0.3-0.8-0.5-1.7-0.4-2.6  c0.1-0.9,0.5-1.7,1.1-2.3c0.5-0.7,1.2-1.1,2-1.3c0.8-0.1,0.8,0.2,0.1,0.5c-0.6,0.3-1.1,0.8-1.4,1.5c-0.3,0.6-0.5,1.2-0.5,1.8  c0,0.6,0.2,1.2,0.6,1.7c0.6,1,1.7,1.7,2.9,1.9c1.2,0.2,2.4-0.1,3.3-0.8c0.9-0.7,1.6-1.7,2-2.8c0.3-1.1,0.4-2.4,0.1-3.5  c-0.3-1.1-0.9-2.2-1.7-3c-0.4-0.4-0.9-0.7-1.4-1c-0.5-0.3-1.1-0.5-1.7-0.7c-0.6-0.2-1.2-0.3-1.8-0.4c-0.6,0-1.2,0-1.8,0.1  c-1.2,0.2-2.4,0.7-3.4,1.4c-2.1,1.5-3.5,3.8-4,6.4c-0.2,1.3-0.2,2.7,0,4c0.1,0.7,0.3,1.3,0.5,2c0.2,0.7,0.5,1.3,0.8,2  c0.6,1.3,1.5,2.4,2.6,3.3C11.5,26,12.8,27.5,12.1,27.2z"></path>
                                                                                        </svg> </span></div>
                                                                                        <div className="row_wrap"> <span className="row row_head"  ><span className="instancename">{ instance.name.length > 0 ? instance.name : instance.name.slice(0, 15) }</span></span><span className="row row_info">{ instance.description }</span> </div>
                                                                                    </div>
                                                                                    <div className={ this.state.isOpChecked ? "col col2 operation_field_col" : "col col2 operation_field_col col-hide" } ><span className="operation"> { instance.operation }</span>
                                                                                    </div>
                                                                                    <div className={ this.state.isEmailChecked ? "col col3 email_field_col" : "col col3 email_field_col col-hide" }> <span className="email">{ instance.username } </span></div>
                                                                                    <div className={ this.state.isIpChecked ? "col col4 ip_field_col" : "col col4 ip_field_col col-hide" }> { instance.ipaddress } </div>
                                                                                    <div className={ this.state.isWhenChecked ? "col col5 when_field_col" : "col col5 when_field_col col-hide" } > <span>{ instance.date } </span></div>
                                                                                </li>
                                                                            ) }
                                                                        </ul>
                                                                    }
                                                                </div>
                                                                <div className="pagination_inner__box remove-bg" style={ { display: this.state.instanceactivities.length > this.state.count ? '' : 'none' } }>
                                                                    <div className="Page_navigation">
                                                                        <ul className="pagination_ul">
                                                                            <li className={ this.state.instIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page1" onClick={ (event) => { this.handleInstPreviousClick(event); } }>
                                                                                    <ReactTooltip id="prev-page1" place="top" effect="solid">Previous</ReactTooltip>
                                                                                    <span aria-hidden="true">«</span>
                                                                                    <span className="sr-only">Previous</span>
                                                                                </a>
                                                                            </li>
                                                                            <li className="page-item">
                                                                                <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                                    { this.state.instIndexCount + 1 } - { (this.state.instIndexCount + this.state.count) > this.state.instanceactivities.length ? this.state.instanceactivities.length : (this.state.instIndexCount + this.state.count) }
                                                                                </a>
                                                                            </li>
                                                                            <li className={ this.state.instIndexCount + this.state.count > this.state.instanceactivities.length - 1 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page1" onClick={ (event) => { this.handleInstNextClick(event); } }>
                                                                                    <ReactTooltip id="next-page1" place="top" effect="solid">Next</ReactTooltip>
                                                                                    <span aria-hidden="true">»</span>
                                                                                    <span className="sr-only">Next</span>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>
                    </main>
                    <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: '' }) } />
                </body>
            </div>
        );
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}
export default Webactivitylogs;